export const BUDDIES_PAIR = 'pair' as const;
export const BUDDIES_A = 'A' as const;
export const BUDDIES_I = 'I' as const;
export type BuddiesWho = typeof BUDDIES_PAIR | typeof BUDDIES_A | typeof BUDDIES_I;

export const BUDDIES_FIT_ORB = 'orb' as const;
export const BUDDIES_FIT_FILL = 'fill' as const;
export type BuddiesFit = typeof BUDDIES_FIT_ORB | typeof BUDDIES_FIT_FILL;

export const BUDDIES_BUSY = 'busy' as const;

export const BUDDIES_DEFAULT_SIZE = 150;

/** The frame drawn when motion is reduced: both buddies upright, eyes open. */
export const BUDDIES_STILL_TIME = 1.2;
